import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { FormControlLabel, FormHelperText, Radio, RadioGroup } from "@material-ui/core";
import { CalculateStore } from "../../../../stores/calculateStore";
import { PolicyDurationId, PolicyDurationVariants } from "../../../../helpers/additionalQuestions/policyDuration";
import FormControl from "@material-ui/core/FormControl";
import Notification from "../../../sharedComponents/notification/notification";
import { PaymentModeId } from "../../../../helpers/additionalQuestions/paymentMode";
import { RisksNetworkTypes } from "../../../../helpers/risksNetwork";

interface PolicyDurationProps {
  calculateStore?: CalculateStore;
}

export function PolicyDuration(props: PolicyDurationProps) {

  const calculateStore = props.calculateStore!;
  const policyDurationRiskNetwork = props.calculateStore!.packages.get(calculateStore.selectedPackage)?.policyDuration;
  const policyDuration = props.calculateStore!.additionalQuestions.policyDuration;

  useEffect(() => {
    refreshPolicyDurationInStore(policyDurationRiskNetwork?.months36, PolicyDurationId.MONTHS_36, PolicyDurationId.MONTHS_12);
    refreshPolicyDurationInStore(policyDurationRiskNetwork?.months12, PolicyDurationId.MONTHS_12, PolicyDurationId.MONTHS_36);
  });

  const onChange = (event: any) => {
    calculateStore.setPolicyDuration(event.target.value);

    if ((event.target.value === PolicyDurationId.MONTHS_12 && unavailablePaymentModeForMonths12()) ||
      (event.target.value === PolicyDurationId.MONTHS_36 && unavailablePaymentModeForMonths36())) {
      calculateStore.setPaymentMode("");
    }
    validate();
  };

  return (

    <div className="additional-questions-section policy-duration">
      <div className="question-answer-container">
        <div className="question">Na jaki okres ma zostać zawarta umowa?</div>
        <FormControl error={!!policyDuration.errorMessage}>
          <RadioGroup
            className={(!!policyDuration.errorMessage) ? "error-message question-radio" : "question-radio"}
            onChange={onChange}
            value={calculateStore.additionalQuestions.policyDuration.value}>
            {PolicyDurationVariants.map((variant) => renderOption(variant.value, variant.label))}
          </RadioGroup>
          {policyDuration.errorMessage && (
            <FormHelperText>
              <Notification type="error" message={policyDuration.errorMessage} />
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </div>
  );

  function renderOption(value: PolicyDurationId | undefined, label: string | null) {
    return (
      <FormControlLabel
        key={"option_" + value}
        disabled={shouldDisablePolicyDuration(value)}
        value={value}
        control={<Radio className={(!!policyDuration.errorMessage) ? "error-radio" : ""} />}
        label={
          <div className={"option option_" + value}>
            <div className="option-label">
              {label}
            </div>
          </div>}
      />
    );
  }

  function shouldDisablePolicyDuration(duration: PolicyDurationId | undefined) {
    if (checkPolicyDuration(duration, PolicyDurationId.MONTHS_12) && shouldDisablePolicy(policyDurationRiskNetwork?.months12)) {
      return true;
    }
    return checkPolicyDuration(duration, PolicyDurationId.MONTHS_36) && shouldDisablePolicy(policyDurationRiskNetwork?.months36);
  }

  function shouldDisablePolicy(duration: RisksNetworkTypes | undefined) {
    return duration === RisksNetworkTypes.notAvailable;
  }

  function refreshPolicyDurationInStore(durationAvailability: RisksNetworkTypes | undefined, selectedDuration: PolicyDurationId, changeToDuration: PolicyDurationId) {
    if (shouldDisablePolicy(durationAvailability)
      && checkPolicyDuration(policyDuration.value, selectedDuration)) {
      calculateStore.setPolicyDuration(changeToDuration);
    }
    if (!shouldDisablePolicy(durationAvailability)
      && checkPolicyDuration(calculateStore.additionalQuestions.policyDuration.value, selectedDuration)) {
      calculateStore.setPolicyDuration(selectedDuration);
    }
  }

  function checkPolicyDuration(duration: PolicyDurationId | undefined, durationId: PolicyDurationId) {
    return duration === durationId;
  }


  function validate() {
    policyDuration.validatePolicyDuration();
  }

  function unavailablePaymentModeForMonths12() {
    const paymentModeValue = calculateStore.additionalQuestions.paymentMode.value;
    return paymentModeValue === PaymentModeId.yearly || paymentModeValue === PaymentModeId.quarterly;
  }

  function unavailablePaymentModeForMonths36() {
    return calculateStore.additionalQuestions.paymentMode.value === PaymentModeId.halfYearly;
  }
}

export default inject("calculateStore")(observer(PolicyDuration));
